import Frame from 'controllers/common/turbo_modal/frame';

export default class extends Frame {
  static turboFrameMarkup({ id, src, contentHTML }) {
    return `\
<turbo-frame
  id="${id}"
  src="${src}"
  style="width: 100%"
  disabled
  data-turbo-modal-target="initialFrameContent"
>
  ${contentHTML}
</turbo-frame>
`;
  }

  constructor({ id, src, removeContentOnClose, initialContentElement }) {
    super({ id, initialContentElement });

    this.src = src;
    this.removeContentOnClose = removeContentOnClose;
  }

  onConnect() {
    this._resetContent();
  }

  onOpen() {
    // Perform this check and mutation on open instead of close b/c we can't
    // easily detect all closures (e.g. closed by clicking on the background).
    // However we can detect all opens so instead remove the content
    // just-in-time.
    if (this.removeContentOnClose) {
      this._resetContent();
    }
    this.contentParentElement.firstChild.removeAttribute('disabled');
  }

  // private

  _resetContent() {
    this.contentParentElement.innerHTML = this.constructor.turboFrameMarkup({
      id: this.id,
      src: this.src,
      contentHTML: this.initialContentHTML,
    });
  }
}
